import React from "react";
import styled, { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  @import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.8/dist/web/variable/pretendardvariable-dynamic-subset.css');
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body { font-family: 'Pretendard Variable', -apple-system, BlinkMacSystemFont, sans-serif; background: #F9FAFB; }
`;

const C = { primary: "#2563EB", accent: "#10B981", gray500: "#6B7280", gray700: "#374151", gray900: "#111827" };
const gradientBg = `linear-gradient(135deg, ${C.primary}, #1E40AF, ${C.accent})`;

const Header = styled.header`position:sticky;top:0;z-index:100;background:rgba(255,255,255,.95);backdrop-filter:blur(12px);border-bottom:1px solid #F3F4F6;`;
const HeaderInner = styled.div`max-width:900px;margin:0 auto;display:flex;align-items:center;justify-content:space-between;padding:0 24px;height:64px;`;
const Logo = styled.a`font-size:22px;font-weight:900;text-decoration:none;background:${gradientBg};-webkit-background-clip:text;-webkit-text-fill-color:transparent;`;
const BackLink = styled.a`font-size:14px;color:${C.gray500};text-decoration:none;&:hover{color:${C.primary};}`;

const Container = styled.main`max-width:900px;margin:0 auto;padding:48px 24px 80px;`;
const Title = styled.h1`font-size:32px;font-weight:800;color:${C.gray900};margin-bottom:8px;`;
const Updated = styled.p`font-size:14px;color:${C.gray500};margin-bottom:40px;`;
const Section = styled.section`margin-bottom:36px;`;
const H2 = styled.h2`font-size:20px;font-weight:700;color:${C.gray900};margin-bottom:12px;padding-bottom:8px;border-bottom:2px solid #E5E7EB;`;
const P = styled.p`font-size:15px;color:${C.gray700};line-height:1.8;margin-bottom:12px;`;
const Ol = styled.ol`padding-left:24px;margin-bottom:12px;`;
const Li = styled.li`font-size:15px;color:${C.gray700};line-height:1.8;margin-bottom:6px;`;

const Table = styled.table`width:100%;border-collapse:collapse;margin:12px 0 16px;font-size:14px;`;
const Th = styled.th`text-align:left;padding:10px 12px;background:#F3F4F6;border:1px solid #E5E7EB;color:${C.gray900};font-weight:600;`;
const Td = styled.td`padding:10px 12px;border:1px solid #E5E7EB;color:${C.gray700};vertical-align:top;`;

const Footer = styled.footer`background:${C.gray900};color:rgba(255,255,255,.4);text-align:center;padding:32px 24px;font-size:12px;line-height:1.8;`;

export default function Privacy() {
  return (
    <>
      <GlobalStyle />
      <Header>
        <HeaderInner>
          <Logo href="/">Jumpin</Logo>
          <BackLink href="/">← 홈으로</BackLink>
        </HeaderInner>
      </Header>

      <Container>
        <Title>개인정보처리방침</Title>
        <Updated>시행일: 2026년 3월 21일 | 최종 수정: 2026년 3월 21일</Updated>

        <Section>
          <H2>제1조 (개인정보의 처리 목적)</H2>
          <P>점핀주식회사(이하 "회사")는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 별도의 동의를 받는 등 필요한 조치를 이행합니다.</P>
          <Ol>
            <Li><strong>서비스 제공:</strong> 중국 수출 채널 운영 자동화, 해외 셀러 매칭, 주문·재고·정산 관리 서비스 제공</Li>
            <Li><strong>회원 관리:</strong> 회원 가입, 본인 확인, 서비스 부정 이용 방지, 고지·통지 등</Li>
            <Li><strong>마케팅 활용:</strong> 신규 서비스 개발, 이벤트 및 광고성 정보 제공 (동의 시)</Li>
            <Li><strong>민원 처리:</strong> 민원인의 신원 확인, 민원사항 확인, 처리결과 통보</Li>
          </Ol>
        </Section>

        <Section>
          <H2>제2조 (수집하는 개인정보 항목)</H2>
          <Table>
            <thead>
              <tr><Th>구분</Th><Th>수집 항목</Th><Th>수집 방법</Th></tr>
            </thead>
            <tbody>
              <tr><Td>필수</Td><Td>이메일, 이름, 회사명, 사업자등록번호, 연락처</Td><Td>회원가입, 상담신청</Td></tr>
              <tr><Td>선택</Td><Td>채널 계정 정보, 상품 정보, 주문·배송 데이터</Td><Td>서비스 이용 중 연동</Td></tr>
              <tr><Td>자동수집</Td><Td>IP주소, 쿠키, 방문일시, 서비스 이용기록, 기기정보</Td><Td>서비스 이용 시 자동 생성</Td></tr>
            </tbody>
          </Table>
        </Section>

        <Section>
          <H2>제3조 (개인정보의 보유 및 이용기간)</H2>
          <P>회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.</P>
          <Table>
            <thead>
              <tr><Th>보유 정보</Th><Th>보유 기간</Th><Th>근거</Th></tr>
            </thead>
            <tbody>
              <tr><Td>계약 또는 청약철회 기록</Td><Td>5년</Td><Td>전자상거래법</Td></tr>
              <tr><Td>대금결제 및 재화 공급 기록</Td><Td>5년</Td><Td>전자상거래법</Td></tr>
              <tr><Td>소비자 불만 또는 분쟁처리 기록</Td><Td>3년</Td><Td>전자상거래법</Td></tr>
              <tr><Td>웹사이트 방문기록</Td><Td>3개월</Td><Td>통신비밀보호법</Td></tr>
              <tr><Td>회원 탈퇴 시 개인정보</Td><Td>탈퇴 후 즉시 파기</Td><Td>정보통신망법</Td></tr>
            </tbody>
          </Table>
        </Section>

        <Section>
          <H2>제4조 (개인정보의 제3자 제공)</H2>
          <P>회사는 정보주체의 개인정보를 제1조에서 명시한 범위 내에서만 처리하며, 다음의 경우를 제외하고는 정보주체의 사전 동의 없이 본래의 범위를 초과하여 처리하거나 제3자에게 제공하지 않습니다.</P>
          <Ol>
            <Li>정보주체로부터 별도의 동의를 받은 경우</Li>
            <Li>법률에 특별한 규정이 있는 경우</Li>
            <Li>서비스 제공을 위해 필요한 경우 (해외 셀러 매칭 등) — 이 경우 사전 동의를 받습니다</Li>
          </Ol>
        </Section>

        <Section>
          <H2>제5조 (개인정보 처리의 위탁)</H2>
          <P>회사는 원활한 서비스 제공을 위해 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.</P>
          <Table>
            <thead>
              <tr><Th>수탁업체</Th><Th>위탁 업무</Th><Th>보유 기간</Th></tr>
            </thead>
            <tbody>
              <tr><Td>Amazon Web Services</Td><Td>클라우드 서버 운영, 데이터 저장</Td><Td>위탁계약 종료 시까지</Td></tr>
              <tr><Td>카카오</Td><Td>알림톡 발송, 상담 채널 운영</Td><Td>위탁계약 종료 시까지</Td></tr>
            </tbody>
          </Table>
        </Section>

        <Section>
          <H2>제6조 (정보주체의 권리·의무 및 행사방법)</H2>
          <P>정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.</P>
          <Ol>
            <Li>개인정보 열람 요구</Li>
            <Li>오류 등이 있을 경우 정정 요구</Li>
            <Li>삭제 요구</Li>
            <Li>처리정지 요구</Li>
          </Ol>
          <P>권리 행사는 이메일(biz@jumpin.kr)을 통해 하실 수 있으며, 회사는 이에 대해 지체 없이 조치하겠습니다.</P>
        </Section>

        <Section>
          <H2>제7조 (개인정보의 파기)</H2>
          <Ol>
            <Li>회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다.</Li>
            <Li>전자적 파일 형태의 정보는 복구 및 재생이 불가능한 방법으로 파기하며, 종이 문서는 분쇄기로 분쇄하거나 소각합니다.</Li>
          </Ol>
        </Section>

        <Section>
          <H2>제8조 (개인정보의 안전성 확보조치)</H2>
          <P>회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</P>
          <Ol>
            <Li>개인정보의 암호화 (비밀번호, 고유식별정보 등)</Li>
            <Li>해킹 등에 대비한 기술적 대책 (방화벽, 침입탐지시스템 운영)</Li>
            <Li>개인정보 접근 제한 (접근권한 관리, 접근통제시스템 운용)</Li>
            <Li>접속기록의 보관 및 위변조 방지 (최소 1년 이상)</Li>
          </Ol>
        </Section>

        <Section>
          <H2>제9조 (개인정보 보호책임자)</H2>
          <Table>
            <thead>
              <tr><Th>구분</Th><Th>내용</Th></tr>
            </thead>
            <tbody>
              <tr><Td>성명</Td><Td>전지혜</Td></tr>
              <tr><Td>직위</Td><Td>대표이사</Td></tr>
              <tr><Td>이메일</Td><Td>biz@jumpin.kr</Td></tr>
            </tbody>
          </Table>
          <P>정보주체는 서비스를 이용하면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자에게 문의하실 수 있습니다.</P>
        </Section>

        <Section>
          <H2>제10조 (권익침해 구제방법)</H2>
          <P>정보주체는 아래의 기관에 대해 개인정보 침해에 대한 피해구제, 상담 등을 문의하실 수 있습니다.</P>
          <Ol>
            <Li>개인정보침해신고센터: (국번없이) 118 / privacy.kisa.or.kr</Li>
            <Li>개인정보분쟁조정위원회: 1833-6972 / www.kopico.go.kr</Li>
            <Li>대검찰청 사이버수사과: (국번없이) 1301 / www.spo.go.kr</Li>
            <Li>경찰청 사이버안전국: (국번없이) 182 / cyberbureau.police.go.kr</Li>
          </Ol>
        </Section>

        <Section>
          <H2>부칙</H2>
          <P>본 개인정보처리방침은 2026년 3월 21일부터 시행합니다.</P>
        </Section>
      </Container>

      <Footer>
        점핀주식회사 | 대표: 전지혜 | 사업자등록번호: 127-81-56735<br />
        광주광역시 임방울대로154-19 1층 | 이메일: biz@jumpin.kr<br />
        © {new Date().getFullYear()} Jumpin. All rights reserved.
      </Footer>
    </>
  );
}
